import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { PullToRefresh } from "@src/appV2/lib/PullToRefresh/PullToRefresh";
import { useIsLimitedAccessWorker } from "@src/appV2/redesign/ShiftDiscovery/LimitedAccess/hooks";
import { PageHeaderWrapper } from "@src/appV2/redesign/system/ui-components";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";
import { useHistory } from "react-router-dom";

import { Button } from "../../../components/Button";
import { IconButton } from "../../../components/IconButton";
import { PageHeaderTopRow } from "../../../components/PageHeaderTopRow";
import { CLIPBOARD_SCORE_SHARE_FULL_PATH } from "../../utils/paths";
import { isScoreHealthy } from "../../utils/utils";

interface ClipboardScorePageHeaderProps {
  clipboardScore: number;
  shiftsWorked: number;
  onRefresh: () => Promise<void>;
}

export function ClipboardScorePageHeader(props: ClipboardScorePageHeaderProps) {
  const { clipboardScore, shiftsWorked, onRefresh } = props;
  const isLimitedAccessWorker = useIsLimitedAccessWorker();
  const { openArticle } = useZendeskArticle();
  const { clipboardScoreSupportLink } = useSupportLinks();
  const history = useHistory();

  const isShareClipboardScoreEnabled = useCbhFlag(CbhFeatureFlag.SHARE_CLIPBOARD_SCORE, {
    defaultValue: false,
  });

  const handleInfoClick = async () => {
    await openArticle(clipboardScoreSupportLink);
  };

  const handleShareClick = () => {
    history.push(CLIPBOARD_SCORE_SHARE_FULL_PATH, {
      entryPoint: "clipboard-score-page",
    });
  };

  return (
    <PageHeaderWrapper
      sx={{
        background: (theme) => {
          if (isLimitedAccessWorker) {
            return theme.palette.intent?.warning?.gradient;
          }

          return isScoreHealthy(clipboardScore)
            ? theme.palette.onboarding?.inProgress.gradient
            : theme.palette.onboarding?.error.gradient;
        },
      }}
    >
      <PageHeaderTopRow
        rightAction={
          isShareClipboardScoreEnabled && shiftsWorked > 0 && clipboardScore > 100 ? (
            <Button
              startIconType="share"
              size="small"
              variant="outlined"
              onClick={handleShareClick}
            >
              Share
            </Button>
          ) : (
            <IconButton
              iconType="info"
              size="medium"
              variant="outlined"
              onClick={handleInfoClick}
            />
          )
        }
      />
      <PullToRefresh onRefresh={onRefresh} />
    </PageHeaderWrapper>
  );
}
